module.exports = __webpack_public_path__ + "fonts/opensans-bolditalic.3122ddd6.woff";